<ion-header class="ion-no-border premium-header">
  <div class="header-curve"></div>
  <div class="custom-toolbar">
    <div class="toolbar-content">
      <ion-buttons slot="start">
        <ion-button (click)="close()" class="icon-btn">
          <ion-icon name="close"></ion-icon>
        </ion-button>
      </ion-buttons>

      <div class="title-group">
        <div class="title-main">{{ selectionMode ? 'Vincular Inspección' : 'Inspecciones' }}</div>
        <div class="title-sub">Gestión de solicitudes e inspecciones</div>
      </div>

      <ion-buttons slot="end" *ngIf="!selectionMode">
        <ion-button (click)="toggleSearch()" class="icon-btn">
          <ion-icon name="search-outline"></ion-icon>
        </ion-button>
        <ion-button (click)="loadInspecciones()" class="icon-btn">
          <ion-icon name="refresh-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
    </div>
  </div>
  <ion-searchbar *ngIf="showSearch && !selectionMode" placeholder="Buscar..." (ionInput)="search($event)" mode="ios" [debounce]="250" class="premium-searchbar" style="margin: 0 16px 10px;"></ion-searchbar>
</ion-header>

<ion-content class="premium-content-bg" [fullscreen]="true">

  <div class="list-container">
    
    <!-- Loading state -->
    <div *ngIf="isLoading" class="loading-state">
      <ion-spinner name="bubbles"></ion-spinner>
      <p>Cargando inspecciones...</p>
    </div>

    <!-- Empty state -->
    <div *ngIf="!isLoading && displayedInspecciones.length === 0" class="empty-state">
      <ion-icon name="search-outline"></ion-icon>
      <p>No se encontraron solicitudes</p>
    </div>

    <!-- Cards -->
    <div class="premium-card inspeccion-card" *ngFor="let item of displayedInspecciones" (click)="selectInspeccion(item)">
      <div class="card-indicator"></div>

      <div class="card-main-col">
        <div class="card-content-upper">
          <div class="card-body">
            <div class="card-header-row">
              <span class="card-id">#{{ item.id }}</span>
              <div class="estado-badge" [ngStyle]="getEstadoColor(item.estado)">
                {{ item.estado }}
              </div>
            </div>

            <div class="card-main-info">
              <h2 class="cliente-title">{{ item.cliente }}</h2>
              <div class="info-row" *ngIf="item.direccion">
                <ion-icon name="location-outline"></ion-icon>
                <span>{{ item.direccion }}</span>
              </div>
              <div class="info-row" *ngIf="item.solicitante">
                <ion-icon name="person-outline"></ion-icon>
                <span>{{ item.solicitante }}</span>
              </div>
              <p class="desc-text" *ngIf="item.descripcion">{{ item.descripcion }}</p>
            </div>
          </div>
        </div>

        <div class="card-footer-row">
          <span class="fecha-txt" *ngIf="item.fecha_creacion">{{ item.fecha_creacion | date:'dd/MM/yyyy' }}</span>
          <span class="action-hint">Toca para vincular <ion-icon name="chevron-forward-outline"></ion-icon></span>
        </div>
      </div>
    </div>

  </div>

</ion-content>
